import React, { useState, useRef, useEffect, CSSProperties } from "react";
import styles from "./styles.module.scss";
import { DownArrow } from "pages/support-tickets/icons";
import { ConditionalRenderer } from "components";

export function PrioritySelect({
  options,
  placeholder,
  onChange,
  variant,
  defaultOption,
}: any) {
  const [isOpen, setIsOpen] = useState<any>(false);
  const [selectedOption, setSelectedOption] = useState<any>(null);

  useEffect(() => {
    setSelectedOption(defaultOption || null);
  }, [defaultOption]);

  const selectRef = useRef<any>(null);

  const handleToggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    setIsOpen(false);
    onChange(option);
  };

  const handleClickOutside = (event: any) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${styles["custom-select"]} ${styles[variant]}`}
      ref={selectRef}
    >
      <div
        className={styles["custom-select__header"]}
        onClick={handleToggleDropdown}
      >
        <div className={styles.textWithCircle}>
          <ConditionalRenderer condition={selectedOption?.color}>
            <span
              className={styles.circle}
              style={{ backgroundColor: `${selectedOption?.color}` }}
            />
          </ConditionalRenderer>
          <span
            className={
              selectedOption ? styles.selectedLable : styles.placeholder
            }
          >
            {selectedOption ? selectedOption.label : placeholder}
          </span>
        </div>
        <span
          className={`${styles["custom-select__arrow"]} ${
            isOpen ? styles["isOpen"] : ""
          }`}
        >
          <DownArrow />
        </span>
      </div>
      {isOpen && (
        <ul className={styles["custom-select__options"]}>
          {options.map((option: any) => (
            <li
              key={option.value}
              className={`${styles["custom-select__option"]} ${
                styles[
                  selectedOption && selectedOption.value === option.value
                    ? "selected"
                    : ""
                ]
              }`}
              onClick={() => handleOptionClick(option)}
              style={{ "--color": option?.color || "#006AB3" } as CSSProperties}
            >
              <ConditionalRenderer condition={option?.color}>
                <span></span>
              </ConditionalRenderer>
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
